<template>
  <div class="timer">
    <div class="fpx-dir">
      <img src="../assets/fpx-dir.png" alt='loading'></img>
    </div>
    <div>
      <h3 class="timeout">
        {{countDownText}}
      </h3>
    </div>
  </div>
</template>

<script>
  import { EXPIR_TIME_CONST } from '../../static/expir/ExpirTime.js'
  import jwt_decode from 'jwt-decode'
  export default {
    name: 'ExpirTime',
    props: {
      startAction: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        countSecond: 0,// 总计时
        countDownTime: 0,// 倒计时
        countDownText: EXPIR_TIME_CONST.TIPS + '\n00:00',
        timerId: null,
        title: EXPIR_TIME_CONST.TITLE
      }
    },

    created() {
      // 开始
      if (this.startAction) {
        this.initInteval()
      }
      if (!this.getTimerStatus()) {
        this.doSetInteval()
      }
    },

    mounted() {
      // 挂载成功后 设置timeoutStatus回调函数
      this.$emit('timeoutStatus', false)
      // 避免断针
      if (window.sessionStorage.getItem('timer_countDownText')) {
        this.countDownText = window.sessionStorage.getItem('timer_countDownText')
      }
    },

    methods: {
      // 获取计时器是否已经超时
      getTimerStatus() {
        let status = window.sessionStorage.getItem('timer_timeoutStatus')
        if (status == undefined || status == null || status == '' || status == 'false') {
          status = 'false';
        } else {
          status = 'true';
        }
        return JSON.parse(status)
      },

      // 初始化显示数据
      initShowContent() {
        this.countDownTime = 0
        this.countDownText = EXPIR_TIME_CONST.TIPS + '\n00:00'
        window.sessionStorage.removeItem('timer_endTime')// 删除结束时间
        window.sessionStorage.removeItem('timer_countSecond')//删除总秒
        window.sessionStorage.removeItem('timer_countDownText')//删除
        window.sessionStorage.setItem('timer_timeoutStatus', this.getTimerStatus())// 超时状态
        clearInterval(this.timerId)// 清除计时器
      },

      // 初始化计时数据
      initInteval() {
        window.sessionStorage.setItem('timer_timeoutStatus', this.getTimerStatus())
        window.sessionStorage.setItem('timer_countSecond', EXPIR_TIME_CONST.MINUTES * 60)
      },

      // 清除
      clearTimer() {
        window.sessionStorage.removeItem('timer_timeoutStatus')
        window.sessionStorage.setItem("clearTimerFlag", "true");
      },

      // 计时器
      doSetInteval() {
        this.countDownTime = this.getCount()
        let taskId = setInterval(() => {
          if (this.countDownTime <= 1) {
            clearInterval(taskId);
            let timerFlag = window.sessionStorage.getItem("timer_timeoutStatus");
            if ((timerFlag == undefined || timerFlag == null)
              && window.sessionStorage.getItem("clearTimerFlag")) {
              return;
            }
            // 设置超时状态回调函数
            this.$emit('timeoutStatus', true)
            window.sessionStorage.setItem('timer_timeoutStatus', true)
            window.sessionStorage.setItem('message', 'You have exceeded the time limit.')

            let statusCode = window.sessionStorage.getItem('statusCode');
            let ruri = window.location.hash;
            if (ruri.indexOf("/login") != -1) {
              statusCode = "1A"
            } else if (ruri.indexOf("/paymentOne") != -1) {
              statusCode = "1D"
            } else if (ruri.indexOf("/paymentTwo") != -1) {
              statusCode = "1J"
            }
            window.sessionStorage.setItem('statusCode', statusCode)
            this.$router.replace({ name: 'ReturnToFpx' })

          } else {
            --this.countDownTime
            let mm = Math.floor(this.countDownTime / 60)
            mm = mm < 10 ? ('0' + mm) : mm
            let ss = Math.floor(this.countDownTime % 60)
            ss = ss < 10 ? ('0' + ss) : ss
            this.countDownText = EXPIR_TIME_CONST.TIPS + '\n' + mm + ':' + ss
          }
          window.sessionStorage.setItem('timer_countDownText', this.countDownText)
        }, 1000)
      },

      // 获取剩余时间
      getCount() {
        let pageCount = window.sessionStorage.getItem('pageCount')
        if (pageCount != 1) {
          let remainTime = window.sessionStorage.getItem('remainTime')
          let skipTime = (new Date().getTime() - window.sessionStorage.getItem('cdateNow')) / 1000
          return remainTime - skipTime
        }

        let token = window.sessionStorage.getItem('sessionToken')
        let decoded = jwt_decode(token)
        if (decoded !== undefined) {
          let endTime = decoded.exp * 1000
          let cdate = new Date(window.sessionStorage.getItem('date'))
          if (cdate == null || cdate == undefined || cdate < new Date(1970, 10, 10)) {
            window.sessionStorage.setItem('remainTime', 900)
            window.sessionStorage.setItem('cdateNow', new Date().getTime())
            return 900;
          }
          let remainTime = (endTime - cdate.getTime()) / 1000
          window.sessionStorage.setItem('remainTime', remainTime)
          window.sessionStorage.setItem('cdateNow', new Date().getTime())
          return remainTime
        } else {
          return -1
        }
      },

    }
  }
</script>


<style lang="less" scoped>
  @media screen and (max-width: 370px) {
    @import "../styles/mobile/m_timeout.less";
  }

  @media screen and (min-width: 371px) and (max-width: 400px) {
    @import "../styles/mobile_b/m_timeout.less";
  }

  @media screen and (min-width: 401px) and (max-width: 640px) {
    @import "../styles/mobile_p/m_timeout.less";
  }

  @media screen and (min-width: 641px) and (max-width: 800px) {
    @import "../styles/pad/timeout.less";
  }

  @media screen and (min-width: 801px) and (max-width: 1200px) {
    @import "../styles/pad_pro/timeout.less";
    .timer {
      position: absolute;
      right: 2vw;
      top: 1vh;
    }
  }

  @media screen and (min-width: 1201px) {
    @import "../styles/pc/timeout.less";
  }
</style>


// WEBPACK FOOTER //
// src/views/ExpirTime.vue